import Departamento, { FinderDepartamentos, RetornoDepartamento } from 'Interface/Departamentos';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Departamentos';

const url = '/departamentos';

const apiExtendida = api.enhanceEndpoints({
    addTagTypes: [tag],
}).injectEndpoints({
    endpoints: construtor => ({
        recuperarDepartamentos: construtor.query<FinderDepartamentos, Parametros | void>({
            query: (params) => `${url}?${paramsParaString(params)}`,
            providesTags: (resultado) => resultado?.departamentos
                ? [
                    ...resultado.departamentos.map(({ id }) => ({ type: tag, id } as const)),
                    { type: tag, id: 'LISTA' },
                ]
                : [{ type: tag, id: 'LISTA' }],
        }),
        recuperarDepartamento: construtor.query<RetornoDepartamento, string | number | Parametros>({
            query: params => {
                let id: number;
                let query: Parametros = {};

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                    query = paramsParaString(params);
                }

                return `${url}/${id}?${query}`;
            },
            providesTags: (resultado, erro, params) => {
                let id: number;

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                }

                return [{ type: tag, id }];
            },
        }),
        adicionarDepartamento: construtor.mutation<Departamento, Partial<Departamento>>({
            query: (dados) => ({ url: url, method: 'POST', body: formData(dados, 'POST') }),
            invalidatesTags: (resultado, erro) => !erro ? [{ type: tag, id: 'LISTA' }] : [],
        }),
        editarDepartamento: construtor.mutation<Departamento, Partial<Departamento> & Pick<Departamento, 'id'>>({
            query: ({ id, ...dados }) => ({ url: `${url}/${id}`, method: 'POST', body: formData(dados, 'PUT') }),
            invalidatesTags: (resultado, erro, { id }) => !erro ? [{ type: tag, id }] : [],
        }),
    }),
    overrideExisting: false,
});

export const {
    useRecuperarDepartamentosQuery,
    useRecuperarDepartamentoQuery,
    useAdicionarDepartamentoMutation,
    useEditarDepartamentoMutation,
} = apiExtendida;
